import { render, staticRenderFns } from "./tzView.vue?vue&type=template&id=c4f66568&scoped=true"
import script from "./tzView.vue?vue&type=script&lang=js"
export * from "./tzView.vue?vue&type=script&lang=js"
import style0 from "./tzView.vue?vue&type=style&index=0&id=c4f66568&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f66568",
  null
  
)

export default component.exports